import { Button, Grid } from '@mui/material';
import React from 'react';
import CAppSubTitle from '../../../../../app/components/CAppSubTitle';

const CTestUiButtons = () => {
	return (
		<>
			<Grid container spacing={3}>
				<Grid item sm={3}>
					<CAppSubTitle title="Size" subtitle="Large" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Button variant="outlined" size="large" color="primary">
								Outlined - Large
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="contained" size="large" color="primary">
								Contained - Large
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="text" size="large" color="primary">
								Text - Large
							</Button>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Size" subtitle="Medium" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Button variant="outlined" size="medium" color="primary">
								Outlined - Medium
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="contained" size="medium" color="primary">
								Contained - Medium
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="text" size="medium" color="primary">
								Text - Medium
							</Button>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Size" subtitle="Small" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Button variant="outlined" size="small" color="primary">
								Outlined - Small
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="contained" size="small" color="primary">
								Contained - Small
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="text" size="small" color="primary">
								Text - Small
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<Grid container spacing={3}>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors" subtitle="Inherit" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Button variant="outlined" size="medium" color="inherit">
								Outlined - Inherit
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="contained" size="medium" color="inherit">
								Contained - Inherit
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="text" size="medium" color="inherit">
								Text - Inherit
							</Button>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors" subtitle="Primary" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Button variant="outlined" size="medium" color="primary">
								Outlined - Primary
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="contained" size="medium" color="primary">
								Contained - Primary
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="text" size="medium" color="primary">
								Text - Primary
							</Button>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors" subtitle="Secondary" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Button variant="outlined" size="medium" color="secondary">
								Outlined - Secondary
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="contained" size="medium" color="secondary">
								Contained - Secondary
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="text" size="medium" color="secondary">
								Text - Secondary
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<Grid container spacing={3}>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors" subtitle="Info" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Button variant="outlined" size="medium" color="info">
								Outlined - Info
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="contained" size="medium" color="info">
								Contained - Info
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="text" size="medium" color="info">
								Text - Info
							</Button>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors" subtitle="Success" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Button variant="outlined" size="medium" color="success">
								Outlined - Success
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="contained" size="medium" color="success">
								Contained - Success
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="text" size="medium" color="success">
								Text - Success
							</Button>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors" subtitle="Warning" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Button variant="outlined" size="medium" color="warning">
								Outlined - Warning
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="contained" size="medium" color="warning">
								Contained - Warning
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="text" size="medium" color="warning">
								Text - Warning
							</Button>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors" subtitle="Error" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<Button variant="outlined" size="medium" color="error">
								Outlined - Error
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="contained" size="medium" color="error">
								Contained - Error
							</Button>
						</Grid>
						<Grid item sm={12}>
							<Button variant="text" size="medium" color="error">
								Text - Error
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};

export default CTestUiButtons;
